export const fmtMoney = (v, opts = {}) => {
    if (v == null || isNaN(v)) return "—";
    const { unit = "M", compact = false, decimals = 1 } = opts;
    const abs = Math.abs(v);
    if (compact && abs >= 1000) return `$${(v / 1000).toFixed(1)}B`;
    return `$${v.toFixed(decimals)}${unit}`;
};

export const fmtNum = (v, decimals = 0) => {
    if (v == null || isNaN(v)) return "—";
    return v.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const fmtPct = (v, decimals = 1) => {
    if (v == null || isNaN(v)) return "—";
    const s = v >= 0 ? "+" : "";
    return `${s}${v.toFixed(decimals)}%`;
};

export const fmtPctPlain = (v, decimals = 1) => {
    if (v == null || isNaN(v)) return "—";
    return `${v.toFixed(decimals)}%`;
};

export const fmtPeriod = (p) => {
    if (!p) return "";
    const [y, m] = p.split("-");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[parseInt(m) - 1]} ${y}`;
};

export const trendColor = (v) => (v >= 0 ? "text-fp-success" : "text-fp-terracotta");
